/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_One_TimeInputs */

const en_settings_payments_tab_one_time = /** @type {(inputs: Settings_Payments_Tab_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time`)
};

const zh_settings_payments_tab_one_time = /** @type {(inputs: Settings_Payments_Tab_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单次购买`)
};

/**
* | output |
* | --- |
* | "One-time" |
*
* @param {Settings_Payments_Tab_One_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_one_time = /** @type {((inputs?: Settings_Payments_Tab_One_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_One_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_payments_tab_one_time(inputs)
	return zh_settings_payments_tab_one_time(inputs)
});
export { settings_payments_tab_one_time as "settings.payments.tab_one_time" }